import { createContext, useContext } from "react";
import type {
  ChangeLogoData,
  GetWelcomeMessageResult,
  InsertWelcomeMessageResult,
  OrgUnitDto,
  UpdateDisplayNameResult,
  UpdateLogoResult,
} from "./canonical";

export interface StorefrontDataContextValue {
  orgUnits: OrgUnitDto[] | undefined;
  isLoading: boolean;
  error: Error | null;
  useLogoData: (orgUnitId: number | null) => ChangeLogoData;
  useUpdateLogo: () => UpdateLogoResult;
  useUpdateDisplayName: () => UpdateDisplayNameResult;
  useGetWelcomeMessage: (orgUnitId: number | null) => GetWelcomeMessageResult;
  useInsertWelcomeMessage: () => InsertWelcomeMessageResult;
}

export const StorefrontDataContext =
  createContext<StorefrontDataContextValue | null>(null);

export function useStorefrontData() {
  const context = useContext(StorefrontDataContext);
  if (!context) {
    throw new Error(
      "useStorefrontData must be used within a StorefrontDataContext provider"
    );
  }
  return context;
}
